import React from 'react';
import ReactApexChart from 'react-apexcharts';
const TreeMap = _ref => {
  let {
    data,
    colors,
    formatter = value => '£' + Math.floor(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') // Default formatter pound sign and comma separated thousands
  } = _ref;
  const series = [{
    data
  }];
  const options = {
    chart: {
      type: 'treemap',
      height: 590
    },
    colors: colors,
    plotOptions: {
      treemap: {
        distributed: true,
        enableShades: true,
        colors: colors
      }
    },
    legend: {
      show: false
    },
    // Always show both label and value on two lines inside each treemap box
    dataLabels: {
      enabled: true,
      style: {
        colors: ['#ffffff'],
        fontSize: '12px',
        fontFamily: 'Franklin Gothic Book, sans-serif'
      },
      formatter: (text, opts) => {
        const value = opts.value;
        return [text, formatter(value)];
      }
    },
    yaxis: {
      labels: {
        style: {
          colors: '#666e7e',
          fontSize: '14px',
          fontFamily: 'Franklin Gothic Book, sans-serif'
        },
        formatter
      }
    }
  };
  return /*#__PURE__*/React.createElement(ReactApexChart, {
    options: options,
    series: series,
    type: "treemap",
    height: 590
  });
};
export default TreeMap;